import { useState } from 'react'
import X from '../assets/close.png'
import '../styles/menu.scss'

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className={`menu ${isOpen ? 'open' : null}`}>
      <button
        className={`menu-button ${isOpen ? 'open' : null}`}
        onClick={() => setIsOpen(true)}
      >
        menu
      </button>
      <button
        className={`close-x ${isOpen ? 'open' : null}`}
        onClick={() => setIsOpen(false)}
      >
        <img src={X} alt="close menu" />
      </button>
      <div className={`menu-items ${isOpen ? 'open' : null}`}>
        <button className="menu-item" onClick={() => setIsOpen(false)}>
          <a href={'./#job-attainment'}>Job Attainment</a>
        </button>
        <button className="menu-item" onClick={() => setIsOpen(false)}>
          <a href={'./#unequal-distribution'}>Unequal Distribution</a>
        </button>
        <button className="menu-item" onClick={() => setIsOpen(false)}>
          <a href={'./#organic-exposure'}>&#8220;Organic&#8221; Exposure</a>
        </button>
        <button className="menu-item" onClick={() => setIsOpen(false)}>
          <a href={'./#career-alignment'}>Career Alignment</a>
        </button>
        <button className="menu-item" onClick={() => setIsOpen(false)}>
          <a href={'./#social-capital'}>Social Capital</a>
        </button>
      </div>
    </div>
  )
}

export default Menu
